<template>
  <el-dialog class="k-point-edit-form" :title="point && point._id ? `Редактирвание акции ${point._id}` : 'Создание новой акции'" :visible.sync="dialogFormVisible">
    <div class="k-point-edit-form__container">
      <p class="k-point-edit-form__title">Вы можете отредактирвать информацию об акции. И сохранить ее в базе данных:</p>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Название места:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="title"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Описание места:</el-col>
        <el-col :span="16"><el-input placeholder="Описание акции" v-model="description" type="textarea" :rows="4"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Страница в Facebook:</el-col>
        <el-col :span="16"><el-input placeholder="Ссылка на мероприятие в facebook" v-model="facebookLink" :rows="4"></el-input></el-col>
      </el-row>


      <!-- <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Дата старта:</el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="Pick a day">
          </el-date-picker>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">Дата окончания:</el-col>
        <el-col :span="16">
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="Pick a day">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-divider></el-divider> -->

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="24">
          <el-transfer
            class="k-point-edit-form__categories"
            filterable
            :filter-method="filterMethod"
            filter-placeholder="Найти категорию"
            :titles="['Не активные', 'Выбранные']"
            v-model="categories"
            :data="categoriesList"
          >
          </el-transfer>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <!-- BEGIN: Загрузка картинок -->
      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">URL логотипа:</el-col>
        <el-col :span="16"><el-input placeholder="URL логотипа" v-model="logoUrl" :rows="4"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">URL изображения:</el-col>
        <el-col :span="16"><el-input placeholder="URL  изображения" v-model="imgUrl" :rows="4"></el-input></el-col>
      </el-row>
      <el-divider></el-divider>

      <!-- <el-row :gutter="20" class="k-point-edit-form__param">
        Логотип партнера:<br>
        <el-upload
          class="k-point-edit-form__upload"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :multiple="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
          <div class="el-upload__tip" slot="tip">jpg/png/svg files with a size less than 500kb</div>
        </el-upload>
      </el-row>
      <el-divider></el-divider> -->
      <!-- END: Загрузка картинок -->

      <k-address
        v-for="(item, index) in addresses"
        :key="index"
        :address="item"
        :number="index"
        :cities="cities"
        @delete="handleDeleteAddress(index)"
      />


       <el-row :gutter="20" class="k-point-edit-form__param">
        <el-col :span="8" class="k-point-edit-form__label">&nbsp;</el-col>
        <el-col :span="16"> <el-button type="primery" icon="el-icon-edit" round size="mini" @click="handleAddAddress">Добавить адрес</el-button></el-col>
      </el-row>

      <el-divider></el-divider>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-button type="success" round @click="handleSave" size="mini" :disabled="!allowToSave">Сохранить</el-button>
        <el-button round @click="handleCancel" size="mini">Отмена</el-button>
      </el-row>

      <el-divider></el-divider>
      <p>* необходимо заполнить все поля</p>
    </div>

  </el-dialog>
</template>

<script>
import { apiGetCities } from '@/api/public';
import { mapGetters, mapActions } from 'vuex';
import KAddress from '@/components/KAddress.vue';
/**
 * Component: k-point-edit-form - Форма для редактирования информации о токене
 *
 * @version 1.0.0
 */
const toStr = param => param ? param : '';
const toBool = param => param ? param : true;
export default {
  name: 'k-point-edit-form',
  props: {
    // Является ли форма видимой
    dialogFormVisible: {
      type: Boolean,
      required: true,
    },
    // Данные точки для отображения
    point: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: '',
      description: '',
      facebookLink: '',
      address: '',
      lng: '',
      lat: '',
      // startDate: null,
      // endDate: null,
      addresses: [],
      categories: [],
      imgUrl: '',
      logoUrl: '',
      cities: [],
    };
  },
  computed: {
    ...mapGetters({
      pointsCategories: 'settings/pointsCategories',
    }),
    categoriesList() {
      const data = [];
      this.pointsCategories.forEach((category, index) => {
        data.push({
          label: category,
          key: index,
        });
      });
      return data;
    },
    allowToSave() {
      return this.title
        && this.categories.length
        && this.addresses.length
        && this.addresses.every(el => el.address && el.city && el.lat && el.lng);
    },
  },
  watch: {
    point: {
      handler: function(newValue) {
        this.setPointData();
      },
      deep: true,
    },
  },
  async created() {
    await this.getAppSettings();
    if (this.point) {
      this.setPointData();
    }
    await this.setCities();
  },
  methods: {
    setPointData() {
      this.title = this.point.title ? this.point.title : '';
      this.description = this.point.description ? this.point.description : '';
      this.facebookLink = this.point.facebookLink ? this.point.facebookLink : '';
      this.address = this.point.address ? this.point.address : '';
      this.lng = this.point.lng ? this.point.lng : '';
      this.lat = this.point.lat ? this.point.lat : '';
      this.logoUrl = this.point.logoUrl ? this.point.logoUrl : '';
      this.imgUrl = this.point.imgUrl ? this.point.imgUrl : '';
      // this.startDate = this.point.startDate ? this.point.startDate : null;
      // this.endDate = this.point.endDate ? this.point.endDate : null;
      this.addresses = this.point.addresses ? this.point.addresses : [];
      this.categories = this.point.categories ? this.point.categories.map(item => this.categoriesList.findIndex(category => category.label === item)) : [];
    },
    async setCities() {
      this.cities = await apiGetCities();
    },
    // Отмена редактирования токена
    handleCancel() {
      this.$emit('cancel');
    },
    // Сохранение информации о токене на бекенде
    async handleSave() {
      const point = {
        title: this.title,
        description: this.description,
        facebookLink: this.facebookLink,
        address: this.address,
        lng: this.lng,
        lat: this.lat,
        logoUrl: this.logoUrl,
        imgUrl: this.imgUrl,
        // startDate: this.startDate,
        // endDate: this.endDate,
        addresses: this.addresses,
        categories: this.categories.map(item => this.categoriesList[item].label),
      };
      if (this.point._id) {
        point._id = this.point._id;
      }
      await this.setPoint(point);
      this.$emit('cancel');
    },
    // Добавление адреса
    handleAddAddress() {
      this.addresses.push({
        address: '',
        city: '',
        lat: '',
        lng: '',
      });
    },
    handleDeleteAddress(index) {
      this.addresses.splice(index, 1);
    },
    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },
    ...mapActions({
      getAppSettings: 'settings/getAppSettings',
      setPoint: 'points/setPoint',
    }),
  },
  components: {
    KAddress,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';
.k-point-edit-form {
  $this: &;
  $icon-size: 50px;
  text-align: left;
  &__container {
    padding: 0 20px;
  }
  &__upload {
    margin: 20px auto;
    text-align: center;
  }
  &__title {
    margin-bottom: 2 * $vp;
  }
  &__param {
    margin-bottom: $vp;
  }
  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }
  &__icon {
    width: $icon-size;
    height: $icon-size;
    margin: 10px auto;
    border-radius: $icon-size / 2;
    background-color: black;
    & svg {
      width: $icon-size;
      height: $icon-size;
    }
  }
}
</style>
